module.exports = __webpack_public_path__ + "400b2c245e7ba5b1263fa55e3fb67886.glb";